import _debounce from 'lodash/debounce';
import Glide from '@glidejs/glide';

const carousel = document.querySelector('.carousel');
if (carousel && carousel.querySelectorAll('.glide__slide').length > 1) {
  const iosSafari = /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(
    navigator.userAgent,
  );
  let theVideo;
  let timeout = null;
  const videos = [];

  const glide = new Glide('.carousel', {
    type: 'carousel',
    startAt: 0,
  }).mount();

  glide.on('move.after', slideLoad);

  function slideLoad() {
    if (theVideo != undefined && !iosSafari) {
      theVideo.pause();
      theVideo.currentTime = 0;
    }

    if (timeout) {
      clearTimeout(timeout);
    }

    const currentSlide = carousel.querySelectorAll(
      '.glide__slide:not(.glide__slide--clone)',
    )[glide.index];
    if (currentSlide.classList.contains('glide__slide--video') && !iosSafari) {
      setupPage();
      theVideo = currentSlide.querySelector('video');
      const promise = theVideo.play();
      if (promise !== undefined) {
        promise
          .then(() => {
            theVideo.addEventListener('ended', videoEnded, false);
          })
          .catch(error => {
            console.log('Video did not play: ', error);
          });
      }
    } else {
      timeout = setTimeout(() => {
        glide.go('>');
      }, 6000);
    }
  }

  function videoEnded() {
    // Resume but also go straight to next slide otherwise it pauses
    //  glide.play();
    glide.go('>');
    theVideo.removeEventListener('ended', videoEnded);
  }

  setupVideos();
  setupPage();
  window.addEventListener('resize', _debounce(setupPage, 200));

  function setupVideos() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.size-to-fit-container'),
      function(el) {
        if (!el.getAttribute('id')) {
          el.setAttribute('id', 'video-id-' + Math.random());
        }

        if (!videos[el.getAttribute('id')]) {
          // set data-ratio of any instances of this video src
          let src = el.querySelector('source').getAttribute('src');

          el.addEventListener(
            'loadedmetadata',
            e => {
              let width = el.videoWidth,
                height = el.videoHeight;

              el.setAttribute('data-ratio', width / height);
              setupPage();
            },
            false,
          );
          videos[el.getAttribute('id')] = true;
        }
      },
    );

    if (
      videos.length < document.querySelectorAll('.size-to-fit-container').length
    ) {
      window.setTimeout(setupVideos, 50);
    }
  }

  function setupPage() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.size-to-fit-container'),
      function(el) {
        if (!el.getAttribute('id')) {
          el.setAttribute('id', 'video-id-' + Math.random());
        }

        if (videos[el.getAttribute('id')]) {
          let container = el.parentNode;
          if (
            container.offsetWidth / container.offsetHeight >
            el.getAttribute('data-ratio')
          ) {
            el.style.width = container.offsetWidth + 10 + 'px';
            el.style.height =
              container.offsetWidth / el.getAttribute('data-ratio') + 'px';
          } else {
            el.style.height = container.offsetHeight + 10 + 'px';
            el.style.width =
              container.offsetHeight * el.getAttribute('data-ratio') + 'px';
          }
        }
      },
    );
  }
}

if (carousel) {
  const initialiseImagesSlides = () => {
    [...carousel.querySelectorAll('[data-image-small]')].forEach(el => {
      if (window.innerWidth < 740) {
        // eslint-disable-next-line no-param-reassign
        el.style.backgroundImage = `url(${el.getAttribute(
          'data-image-small',
        )})`;
      } else {
        // eslint-disable-next-line no-param-reassign
        el.style.backgroundImage = `url(${el.getAttribute(
          'data-image-large',
        )})`;
      }
    });
  };

  initialiseImagesSlides();

  window.addEventListener('resize', initialiseImagesSlides);
}
